import { Dayjs } from 'dayjs';

// eslint-disable-next-line no-shadow
export enum BOOKING_TYPE {
  MEETING_ROOM = 'MEETING_ROOM',
  DAY_PASS = 'DAY_PASS',
}
export interface Location {
  address: string;
  countryCode: string;
  currency: string;
  id: string;
  name: string;
  symbol: string;
  has_12_hours: '0' | '1';
  city?: string;
  latitude?: string;
  longitude?: string;
  // external-daypass getLocations includes the per-day price
  daypass_price?: string;
}

export interface DaypassOffices {
  id: string;
  name: string;
  daypass_price: string;
  valid_date: string;
}

interface ErrorSchema {
  error: boolean;
  message: string;
}

export interface Unit {
  id: string;
  image_link: string;
  max_people_number: string;
  name: string;
  min_booked: string;
  extra_images?: string;
  external_description?: string;
  external_hours_from?: string;
  external_hours_to?: string;
  external_how_to_access?: string;
  amenities?: string;
  bulk_discounts?: string;
}

export interface DayPassBookingData {
  locationId: string;
  quantity: number;
  officeId?: any;
  startDate?: string;
  endDate?: string;
}

export interface MeetingRoomBookingData {
  fromTime: number;
  toTime: number;
  conferenceRoom: string;
  date: string;
  discount_code?: string;
}

export interface BookingCost {
  originalCost: number;
  subTotal: number;
  total: number;
  vat: number;
  currency?: string;
  discountCode?: string | null;
}

export interface FreePeriods {
  [key: number]: number[];
}

export type GetMeetingRoomBookingCost = (
  phpUrl: string,
  bookingData: MeetingRoomBookingData,
) => Promise<BookingCost | ErrorSchema>;

export type GetDayPassBookingCost = (
  phpUrl: string,
  bookingData: DayPassBookingData,
) => Promise<BookingCost | ErrorSchema>;

export type GetFreePeriods = (
  phpUrl: string,
  date: string,
  conferenceRoomIds: string[],
) => Promise<FreePeriods[] | ErrorSchema>;

interface MemberInfo {
  ein: string;
  phonenumber: string;
  company: string;
  email: string;
  name: string;
}

interface PaymentInfo {
  paymentType: string;
  cardNumber: string;
  memberName: string;
  cvc: string;
  billingAddress?: string;
  zip?: string;
  expiraryMonth: string;
  expiraryYear: string;
  expiraryDate: string;
}

interface BookingRoomInfo {
  fromTime: number;
  toTime: number;
  conferenceRoom: string;
  location: string;
  date: string;
  countryCode: string;
  currency: string;
}

interface DayPassInfo {
  quantity: number;
  location: string;
  date: string[];
}

export interface BookingRoomData {
  member_info: MemberInfo;
  payment_info: PaymentInfo;
  booking_info: BookingRoomInfo;
}

export interface BookDayPassData {
  member_info: MemberInfo;
  payment_info: PaymentInfo;
  booking_info: DayPassInfo;
  locationId?: string;
  packageId?: number;
}

export type BookMeetingRoom = (
  phpUrl: string,
  data: {
    booking_info: {
      date: any;
      conferenceRoom: any;
      countryCode: string;
      fromTime: any;
      currency: string;
      location: any;
      toTime: any;
    };
  },
) => Promise<any>;
export type BookDayPass = (phpUrl: string, data: BookDayPassData) => Promise<any>;

// TODO move this type to calendar types
export interface CalendarEvent {
  row: number;
  col: number;
  step: number;
  maxAvailableTime: number;
  minAvailableTime: number;
  title: string;
  date: Dayjs;
  height: number;
  startTime: string;
  endTime: string;
}

// eslint-disable-next-line no-shadow
export enum PACKAGE_TYPE {
  ANNUAL = 'ANNUAL',
  FLOATING = 'FLOATING',
}

export type BuyPackage = (phpUrl: string, data: BookDayPassData) => Promise<any>;
export type GetAvailablePackages = (phpUrl: string, locationId: string, cmdType: string) => Promise<any>;

export interface Package {
  id: number;
  vat: number;
  location_id: number;
  total_price: number;
  credit_price: number;
  currency_code: string;
  currency_name: string;
  currency_symbol: string;
  credit_count: number;
}
